import React, { useEffect, useState } from 'react';
import WanderingWasp from './WanderingWasp';
import VacationPopup from './VacationPopup';
import { ADMIN_API_URL } from '../../config/adminApi';
import { fetchWithTimeout } from '../../utils/fetchWithTimeout';
import './vacation.css';

// Seul point d'entrée à monter dans App.js. Ne rend rien tant qu'aucun popup
// vacances n'est actif — zéro impact sur le reste du site le reste de l'année.
export default function VacationExperience() {
  const [banner, setBanner]       = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    fetchWithTimeout(`${ADMIN_API_URL}/api/banners/active-vacation`)
      .then(data => {
        if (!data) return;
        setBanner(data);
        const dismissedId = sessionStorage.getItem('sdn_vacation_popup_dismissed');
        setPopupOpen(String(data.id) !== dismissedId);
      })
      .catch(() => {});
  }, []);

  if (!banner) return null;

  const closePopup = () => {
    sessionStorage.setItem('sdn_vacation_popup_dismissed', String(banner.id));
    setPopupOpen(false);
  };

  return (
    <>
      <WanderingWasp />
      {popupOpen && <VacationPopup banner={banner} onClose={closePopup} />}
    </>
  );
}
